import styles from "../../static/styles/RoxESL/RoxLanding.module.css";

import roxVip from '../../static/img/RoxESL/RoxVIP.png';

const RoxWelcomeSlide = () => (
    <div className={styles.RoxSlide}>
        <img className={styles.RoxVipImage} src={roxVip} alt="" />
        <span className={styles.RoxWelcome}>WELCOME,</span>
        <span className={styles.RoxUsrname}>TO ESL</span>
        <p className={styles.RoxWelcomeMsg}>You're now part of the elite circle.<br />Unlimited tournaments. Premium rewards.</p>
        <div className={styles.RoxPerks}>
            <div className={styles.RoxPerkItem}>
                <span className={styles.RoxPerkLabel}>UNLIMITED</span>
                <span className={styles.RoxPerkValue}>TOURNAMENTS</span>
            </div>
            <div className={styles.RoxPerkDivider} />
            <div className={styles.RoxPerkItem}>
                <span className={styles.RoxPerkLabel}>+1,000</span>
                <span className={styles.RoxPerkValue}>BONUS CREDITS</span>
            </div>
            <div className={styles.RoxPerkDivider} />
            <div className={styles.RoxPerkItem}>
                <span className={styles.RoxPerkLabel}>VIP</span>
                <span className={styles.RoxPerkValue}>GIFT ACCESS</span>
            </div>
        </div>
    </div>
);

export default RoxWelcomeSlide;
